import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIS } from "../../../../utils/APIS";
import { GET, POST, PUT, DELETE } from "../../../../utils/Methods";
import { IDS } from "../../../../utils/IDS";

//FAQ - Get All (Read)
export const GetAll = createAsyncThunk(
  "faqs/faq/get-all",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Faqs.FAQ}?question=${filter?.question || ""}&answer=${filter?.answer || ""}
        &faq_category_id=${filter?.faq_category_id || ""}&page=${
          filter?.page || IDS.PAGE
        }&per_page=${filter?.per_page || IDS.PERPAGE}`,
      );
      return res;
    } 
    
    catch (error) {
      return rejectWithValue(error.message);
    }
  },
);


// FAQ - Get (Read)
export const GetSingle = createAsyncThunk(
  "faqs/faq/get",
  async (id, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Faqs.FAQ}/${id}`);
      return res;
    } 
    catch (error) {
      return rejectWithValue(error.message);
    }
  },
);


// FAQ - Create (Add)
export const Create = createAsyncThunk(
  "faqs/faq/create",
  async (data, { rejectWithValue }) => {
    try {
      const res = await POST(APIS.Faqs.FAQ, data);
      return res; // The new faq object
    }
     catch (error) {
      return rejectWithValue(error.message);
    }
  },
);


// FAQ - Update
export const Update = createAsyncThunk(
  "faqs/faq/update",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const res = await PUT(`${APIS.Faqs.FAQ}/${id}`, data);
      return res;
    } 
    
    catch (error) {
      return rejectWithValue(error.message);
    }
  },
);



// FAQ - Delete
export const Delete = createAsyncThunk(
  "faqs/faq/delete",
  async (id, { rejectWithValue }) => {
    try {
      const data = await DELETE(`${APIS.Faqs.FAQ}/${id}`);
      return id; // Return the id of the deleted faq
    } 
    catch (error) {
      return rejectWithValue(error.message);
    }
  },
);


//FAQ - Status
export const StatusFAQ = createAsyncThunk(
  "faqs/faq/status",
  async (id, { rejectWithValue }) => {
    try {
      const res = await POST(`${APIS.Faqs.FAQ}/${id}`);
      return res;
    } 
    catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const Slice = createSlice({
  name: "faq",
  initialState: {
    data: [],
    current_page: IDS.PAGE,
    total_pages: IDS.TOTALPAGES,
    per_page: IDS.PERPAGE,
    total: IDS.TOTAL,
    status: IDS.SLICESTATUS.Idle,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Handling all actions for GetSingle, Create, Update, Delete
      .addCase(GetAll.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetAll.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = action.payload?.data?.data || [];
        state.current_page = action.payload?.data?.current_page || IDS.PAGE;
        state.total_pages = action.payload?.data?.total_pages || IDS.TOTALPAGES;
        state.per_page = action.payload?.data?.per_page || IDS.PERPAGE;
        state.total = action.payload?.data?.total || IDS.TOTAL;
      })
      .addCase(GetAll.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(GetSingle.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetSingle.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
      })
      .addCase(GetSingle.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(Create.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(Create.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        // state.data = action.payload;
        state.data.unshift(action.payload.data);
      })
      .addCase(Create.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(Update.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(Update.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        // state.data = action.payload;
        const index = state.data.findIndex(
          (faq) => faq.id === action.payload?.data?.id,
        );
        if (index !== -1) {
          state.data[index] = action.payload.data;
        }
      })
      .addCase(Update.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(Delete.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(Delete.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        // state.data = action.payload;
        state.data = state.data.filter(
          (faq) => faq.id !== action.payload,
        ); // Remove the faq with the deleted id
      })
      .addCase(Delete.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      //
      .addCase(StatusFAQ.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(StatusFAQ.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        // state.data = action.payload;
        state.data = state.data.filter(
          (faq) => faq.id !== action.payload.id,
        ); // Remove the faq with the deleted id
      })
      .addCase(StatusFAQ.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      });
  },
});

// Export actions (if needed in components)
export const {} = Slice.actions;

export default Slice.reducer;
